import _ from 'lodash';

export default function(network, currentUser, currentNavigationLink) {
  const root = `${currentNavigationLink.href}`;

  return _.remove([
    {
      name: `Student Impact`,
      id: 'student-impact',
      href: `${root}/students`,
    },
    {
      name: `Educators`,
      id: 'educators',
      href: `${root}/educators`,
    },
    {
      name: `Partners`,
      id: 'partners',
      href: `${root}/partners`,
    },
    {
      name: `Projects`,
      id: 'projects',
      href: `${root}/projects`,
    },
    {
      name: `Events`,
      id: 'events',
      href: `${root}/events`,
    },
    {
      name: `Offers`,
      id: 'offers',
      href: `${root}/offers`,
    },
    {
      name: `Evaluations`,
      id: 'evaluations',
      href: `${root}/evaluations`,
    },
    {
      name: `Sites`,
      id: 'sites',
      href: `${root}/schools`,
    },
    {
      name: `Organizations`,
      id: 'organizations',
      href: `${root}/organizations`,
    },
    currentUser.data.isStaff && {
      name: `[ Goals Tracking ]`,
      id: 'goals-tracking',
      href: `${root}/goals`,
    }
  ]);
};
